import React, { useState } from "react";
import "../styles/Videos.css";

const videos = [
  {
    title: "MediCureOn Platform Explained",
    description: "Overview of the platform, services, and smart medical devices.",
    thumb: "https://img.youtube.com/vi/0M9jBqtCR28/maxresdefault.jpg",
    videoId: "0M9jBqtCR28",
  },
  {
    title: "What Is MediCoin?",
    description: "Learn about MediCoin and how it fuels the MediCureOn ecosystem.",
    thumb: "https://img.youtube.com/vi/gazIpvWHlDM/maxresdefault.jpg",
    videoId: "gazIpvWHlDM",
  },
  {
    title: "MediCureOn Collaboration",
    description: "An Enterprise-Grade Collaboration with tech giants.",
    thumb: "https://img.youtube.com/vi/hdXaCqiOqiw/maxresdefault.jpg",
    videoId: "hdXaCqiOqiw",
  },
  {
    title: "Next-Gen Healthcare",
    description: "MediCure - A Next-Gen Healthcare Platform!",
    thumb: "https://img.youtube.com/vi/RGM0HqwTQtE/maxresdefault.jpg",
    videoId: "RGM0HqwTQtE",
  },
  {
    title: "Investment Opportunity",
    description: "MediCoin - Token Powering the Future of Healthcare.",
    thumb: "https://img.youtube.com/vi/-eM4KAnCQ9A/maxresdefault.jpg",
    videoId: "-eM4KAnCQ9A",
  },
  {
    title: "ICO Walkthrough: TGE & Claims",
    description: "Walk through MediCoin’s three-stage ICO. Learn how token claims work post-90-day lock.",
    thumb: "https://img.youtube.com/vi/wBThMDZHXWc/maxresdefault.jpg",
    videoId: "wBThMDZHXWc",
  },
  {
    title: "Locking & Vesting Explained",
    description: "Learn how MediCoin uses a 90-day lock and stage-based vesting to protect investors.",
    thumb: "https://img.youtube.com/vi/6xPKmFSrai0/maxresdefault.jpg",
    videoId: "6xPKmFSrai0",
  },
  {
    title: "MediCoin Staking Opportunities",
    description: "Gain while you wait — with five high-yield staking plans offering compounding interest and visual analytics.",
    thumb: "https://img.youtube.com/vi/Zoee4G-Ws2A/maxresdefault.jpg",
    videoId: "Zoee4G-Ws2A",
  },
  {
    title: "MediCoin Burning Strategy",
    description: "Discover how MediCoin plans to burn 30 billion tokens over 36 months.",
    thumb: "https://img.youtube.com/vi/lQUmqNgc5dE/maxresdefault.jpg",
    videoId: "lQUmqNgc5dE",
  },
];

function VideoCard({ video }) {
  const [showModal, setShowModal] = useState(false);

  const handlePlay = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="group block cursor-pointer" onClick={handlePlay}>
        <div className="relative overflow-hidden rounded-2xl border border-yellow-300/30 shadow-lg">
          <img 
            src={video.thumb} 
            alt={video.title} 
            className="w-full h-52 object-cover group-hover:scale-105 transition"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
          <div className="absolute bottom-0 p-4 text-white">
            <p className="text-sm font-semibold">{video.title}</p>
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="rounded-full bg-black/70 border border-yellow-300/50 px-4 py-2 text-white text-sm font-semibold transition-transform group-hover:scale-110 shadow-lg">
              ▶ Watch
            </div>
          </div>
        </div>
        <div className="mt-3 px-2">
          <p className="text-white/80 text-sm leading-relaxed">{video.description}</p>
        </div>
      </div>

      {/* Video Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" onClick={() => setShowModal(false)}>
          <div className="relative max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <button 
              onClick={() => setShowModal(false)}
              className="absolute -top-10 right-0 text-white hover:text-yellow-300 transition text-xl"
            >
              ✕ Close
            </button>
            <div className="bg-black rounded-2xl overflow-hidden">
              <div className="aspect-video">
                <iframe
                  src={`https://www.youtube-nocookie.com/embed/${video.videoId}?autoplay=1&rel=0&modestbranding=1`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                  style={{ border: 'none' }}
                ></iframe>
              </div>
              <div className="p-4">
                <h3 className="text-white font-semibold text-lg">{video.title}</h3>
                <p className="text-white/70 text-sm mt-2">{video.description}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function Videos() {
  return (
    <div className="videos-container">
      {/* ✨ Top Heading Section */}
      <div className="mb-12 text-center">
        <h1 className="videos-title">🎥 MediCoin Video Center</h1>
        <p className="text-gray-300 text-lg max-w-3xl mx-auto mt-4">
          Watch short, impactful videos to learn how MediCoin powers the MediCureOn platform. 
          From <span className="text-purple-400 font-semibold">staking</span> and 
          <span className="text-purple-400 font-semibold"> tokenomics</span> to our 
          <span className="text-purple-400 font-semibold"> presale walkthrough</span> — these clips help you explore our ecosystem, fast.
        </p>
      </div>

      {/* 🎬 Video Grid */}
      <div className="videos-grid">
        {videos.map((video, idx) => (
          <VideoCard key={idx} video={video} />
        ))}
      </div>
    </div>
  );
}
